/**
 * 人のアイコン（#152、docs/61 §5・★f、Figma「アカウントと氏名（10/8）」部品の「人のアイコン」）。
 *   ・丸（会社＝CompanyIcon は角丸の四角なので、形で見分ける）。地 --ai3（#DCE6F0）・藍・太字
 *   ・氏名があれば頭文字（姓の1文字。contract の personInitial）、無ければ人の形
 *   ・氏名はいつも隣に字で出すので、アイコンは読み上げない（aria-hidden）
 *   大きさは size（px）。右上のボタン 36・メニューの頭 48・個人設定の頭 72。字と人の形は CSS の --pi-k（size / 40）で同じ割合（.picon、styles.css「アカウントと氏名（#152）」）
 */
import { personInitial } from "@genbaryoku/contract";
import type { CSSProperties } from "react";

export function PersonIcon({ familyName, givenName, size = 40 }: { familyName: string; givenName: string; size?: number }) {
  const ch = personInitial({ familyName, givenName });
  const style = size === 40 ? undefined : ({ "--pi-k": size / 40 } as CSSProperties);
  return (
    <span className={"picon" + (ch ? "" : " is-none")} style={style} aria-hidden="true" data-testid="person-icon">
      {ch ?? (
        <svg viewBox="0 0 24 24">
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21a8 8 0 0 1 16 0" />
        </svg>
      )}
    </span>
  );
}
